import { Create } from "@/components/admin/create";
import { Edit } from "@/components/admin/edit";
import { List } from "@/components/admin/list";
import { DataTable } from "@/components/admin/data-table";
import { FormToolbar, SimpleForm } from "@/components/admin/simple-form";
import { OwnerToolbar } from "./OwnerLock";
import { FreightTabs } from "./FreightTabs";
import { TextInput } from "@/components/admin/text-input";
import { NumberInput } from "@/components/admin/number-input";
import { NumberField } from "@/components/admin/number-field";
import { SelectInput } from "@/components/admin/select-input";
import {
  CompanyField,
  CompanyInput,
  ListActions,
  OwnerField,
  OwnerInput,
  equipmentChoices,
  money,
} from "./common";

const LaneForm = () => (
  <SimpleForm
    toolbar={
      <OwnerToolbar>
        <FormToolbar />
      </OwnerToolbar>
    }
  >
    <div className="grid grid-cols-2 gap-4 w-full">
      <TextInput source="origin_city" label="Origin city" required />
      <TextInput source="origin_state" label="Origin state" required />
      <TextInput source="destination_city" label="Destination city" required />
      <TextInput
        source="destination_state"
        label="Destination state"
        required
      />
      <SelectInput
        source="equipment_type"
        label="Equipment"
        choices={equipmentChoices}
      />
      <NumberInput source="miles" label="Miles" />
      <NumberInput source="target_rate" label="Target rate ($)" />
      <CompanyInput />
    </div>
    <OwnerInput />
    <TextInput source="notes" label="Notes" multiline />
  </SimpleForm>
);

// generated columns; never send back
const transform = ({ fts: _f, ...d }: any) => d;

export const LaneList = () => (
  <List
    actions={<ListActions />}
    sort={{ field: "created_at", order: "DESC" }}
    title="Lanes"
  >
    <FreightTabs />
    <DataTable rowClick="edit">
      <DataTable.Col
        label="Origin"
        render={(r: any) => `${r.origin_city}, ${r.origin_state}`}
      />
      <DataTable.Col
        label="Destination"
        render={(r: any) => `${r.destination_city}, ${r.destination_state}`}
      />
      <DataTable.Col source="equipment_type" label="Equipment" />
      <DataTable.NumberCol source="miles" label="Miles" />
      <DataTable.Col label="Target rate">
        <NumberField source="target_rate" options={money} />
      </DataTable.Col>
      <DataTable.Col label="Customer">
        <CompanyField />
      </DataTable.Col>
      <DataTable.Col label="Agent">
        <OwnerField />
      </DataTable.Col>
    </DataTable>
  </List>
);
export const LaneCreate = () => (
  <Create transform={transform} redirect="list" title="New lane">
    <LaneForm />
  </Create>
);
export const LaneEdit = () => (
  <Edit transform={transform} redirect="list" title="Edit lane">
    <LaneForm />
  </Edit>
);
export default { list: LaneList, create: LaneCreate, edit: LaneEdit };
